import React from "react"
import { FaEdit, FaTrash } from "react-icons/fa"

export const parseXPTable = ({
  data,
  onStatusClick,
  onEditClick,
  onDeleteClick,
}) => {
  const columns = [
    {
      field: "CEP",
      headerName: "CEP",
      flex: 0.5,
      renderCell: params => (
        <div>{params.row?.CEP ? params.row.CEP : "N/A"}</div>
      ),
    },
    {
      field: "CNPJ",
      headerName: "CNPJ",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row?.CNPJ ? params.row.CNPJ : "N/A"}</div>
      ),
    },
    {
      field: "CNPJRaiz",
      headerName: "CNPJ Raiz",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row?.CNPJRaiz ? params.row.CNPJRaiz : "N/A"}</div>
      ),
    },
    {
      field: "CidadeEstado",
      headerName: "Cidade - Estado",
      flex: 1,
      valueGetter: params => {
        if (!params || !params.row) return "N/A"
        return params.row.Cidade && params.row.UF
          ? `${params.row.Cidade}, ${params.row.UF}`
          : "N/A"
      },
    },
    {
      field: "Endereco",
      headerName: "Endereço",
      flex: 1,
      renderCell: params => (
        <div>{params.row?.Endereco ? params.row.Endereco : "N/A"}</div>
      ),
    },
    {
      field: "Email",
      headerName: "Email",
      flex: 1,
      renderCell: params => (
        <div>{params.row?.Email ? params.row.Email : "N/A"}</div>
      ),
    },
    {
      field: "NomeFantasia",
      headerName: "Nome Fantasia",
      flex: 2,
      renderCell: params => (
        <div>{params.row?.NomeFantasia ? params.row.NomeFantasia : "N/A"}</div>
      ),
    },
    {
      field: "RazaoSocial",
      headerName: "Razão Social",
      flex: 1,
      renderCell: params => (
        <div>{params.row?.RazaoSocial ? params.row.RazaoSocial : "N/A"}</div>
      ),
    },
    {
      field: "Seguradora",
      headerName: "Seguradora",
      flex: 1,
      renderCell: params => (
        <div>{params.row?.Seguradora ? params.row.Seguradora : "N/A"}</div>
      ),
    },
    {
      field: "Corretoras",
      headerName: "Corretoras",
      flex: 1,
      renderCell: params => (
        <div>{params.row?.Corretoras ? params.row.Corretoras : "N/A"}</div>
      ),
    },
    {
      field: "PalavrasChave",
      headerName: "Palavra Chave",
      flex: 1.5,
      renderCell: params => (
        <div>
          {params.row?.PalavrasChave ? params.row.PalavrasChave : "N/A"}
        </div>
      ),
    },
    {
      field: "RangeLeads",
      headerName: "Leads de Alcance",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row?.RangeLeads ? params.row.RangeLeads : "N/A"}</div>
      ),
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{
            color: params.row?.Status === true ? "green" : "inherit",
            cursor: "pointer",
          }}
          onClick={() => onStatusClick(params.row)}
        >
          {params.row?.Status === true ? "Ativo" : "Inativo"}
        </div>
      ),
    },
    {
      field: "Editar",
      headerName: "Editar",
      flex: 0.5,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
            width: "100%",
            height: "100%",
          }}
          onClick={() => onEditClick(params.row)}
        >
          <FaEdit size={18} color="green" />
        </div>
      ),
    },
    {
      field: "Excluir",
      headerName: "Excluir",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
            height: "100%",
          }}
          onClick={() => onDeleteClick(params.row)}
        >
          <FaTrash size={16} color="red" />
        </div>
      ),
    },
  ]

  const rows = data ? data.map(company => ({ ...company, id: company.Id })) : []

  return { columns, rows }
}
